import { Story } from "../../storyV2/domain/Story";
export class SubStory extends Story {
    constructor() {
        super(...arguments);
        this.isNested = true;
    }
}
